var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 20,
  fill: "none",
  viewBox: "0 0 16 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.667,
  d: "M3.373 6.641a4.655 4.655 0 0 1 9.254 0l.21 1.889c.107.969.423 1.903.924 2.739l.482.802c.303.505.454.757.482.96a1 1 0 0 1-.597 1.055c-.189.08-.483.08-1.072.08H2.944c-.589 0-.883 0-1.072-.08a1 1 0 0 1-.597-1.055c.028-.203.18-.455.482-.96l.482-.803c.501-.835.817-1.77.924-2.738z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.667,
  d: "M5.585 14.72c.143.798.456 1.502.893 2.005S7.45 17.5 8 17.5s1.085-.272 1.522-.775.75-1.207.893-2.004"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;